import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { filter, Observable, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SalesQuotationService } from 'src/app/shared/services/sales-quotation.service';
import { UserService } from 'src/app/shared/services/user.service';
import { aioTableLabels } from 'src/assets/static-data/aio-table-data';
import { Permissions } from 'src/assets/static-data/permissions';
import { ISalesQuotation } from 'src/core/interfaces/ISalesQuotation';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { SalesQuotationStatus } from 'src/assets/static-data/enums/sales-quotation-status.enum';
import { TransactionsInternalServicesService } from '../../../../../../../src/app/shared/services/transactions-internal-services.service';
import { SalesQuotationStatusLabels } from 'src/assets/static-data/salesQuotationStatusLabels';
import { User } from 'src/core/interfaces/user';

@UntilDestroy()
@Component({
  selector: 'app-sales-quotation',
  templateUrl: './sales-quotation.component.html',
  styleUrls: ['./sales-quotation.component.scss','../transactions.component.scss'],
  providers: [DatePipe] // Provide DatePipe
})

export class SalesQuotationComponent {

  SalesQuotationStatus = SalesQuotationStatus; // Expose the enum to the template
  ISalesQuotation: ISalesQuotation[];
  permissions = new Permissions();
  currentUser: User;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
  isLoading = false
  isInactiveLoading = false;
  clicked = false;
  lastSyncDate:Date;
  filteredDataStatus:number=-1;
  currentPage = 0;
  //activeCount = 0;
  filteredDataSearch:string=null;
  isRtl:boolean;
  typingTimer: any;
  doneTypingInterval = 800; // Delay in ms

  columns: TableColumn<ISalesQuotation>[] = [
    { label: this.translateService.instant("TRANSACTIONUMBER.TEXT"), property: 'transactionNumber', type: 'text', visible: true },
    { label: this.translateService.instant("TRANSACTIONDATE.TEXT"), property: 'transactionDate', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMERCODE.TEXT"), property: 'customerCode', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMERNAME.TEXT"), property: 'customerName', type: 'text', visible: true },
    { label: this.translateService.instant("STATUS.TEXT"), property: 'status',type:'text', visible: true },
    { label: this.translateService.instant("ACTIONS.TEXT"), property: 'actions', type: 'button', visible: true },
  ];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 250, 500,1000,5000,10000];
  dataSource: MatTableDataSource<ISalesQuotation> | null;
  totalRows = 0;

  //selection = new SelectionModel<IVehicle>(true, []);
  searchCtrl = new UntypedFormControl();
  private destroy$ = new Subject<void>();

  //labels = aioTableLabels;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private dialog: MatDialog,
    private userService: UserService,
    private authService: AuthService, private translateService: TranslateService,
    private salesQuotationService: SalesQuotationService,
    private router: Router,    private datePipe: DatePipe,
    private salesQuotationInternalService:TransactionsInternalServicesService
  ) {
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  

  ngOnInit() {
    this.dataSource = new MatTableDataSource();

this.getSalesQuotaions();
this.isRtl = this.translateService.currentLang == 'ar'|| this.translateService.currentLang == 'ur'?true:false;

// this.searchCtrl.valueChanges.pipe(
//   untilDestroyed(this)
// ).subscribe(value => this.onFilterChange(value));

this.currentUser = this.authService.currentUserValue;

this.userService.checkPermission(this.currentUser?.id, this.permissions.CREATE_SALES_QUOTATION).pipe(takeUntil(this.destroy$)).subscribe(response => {
  this.canAdd = response.data;
})
this.userService.checkPermission(this.currentUser?.id, this.permissions.UPDATE_SALES_QUOTATION).pipe(takeUntil(this.destroy$)).subscribe(response => {
  // debugger
  this.canEdit = response.data;
})
this.userService.checkPermission(this.currentUser?.id, this.permissions.DELETE_SALES_QUOTATION).pipe(takeUntil(this.destroy$)).subscribe(response => {
  this.canDelete = response.data;
})
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnDestroy() {
    // Emit destroy signal to unsubscribe all
    this.destroy$.next();
    this.destroy$.complete();
  }
  getSalesQuotaions(criteria = null){
    // // debugger;
    this.isLoading =true;
    this.salesQuotationService.getPaginatedSalesQuotations(this.currentPage, this.pageSize, true, criteria).pipe(takeUntil(this.destroy$)).subscribe(response => {
      // // debugger;
      this.isLoading = false;
      this.dataSource.data = response.data.items;
      this.dataSource.data.forEach((row) => {
        // Convert status value to its key
      row.status=this.salesQuotationInternalService.getStatusKeyFromValue(row.status,0) as SalesQuotationStatus;
        row.transactionDate = this.datePipe.transform(row.transactionDate, 'dd/MM/yyyy');
      });

      //this.activeCount = response.data.items.length;
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = response.data.count;
      });
      //console.log(response.data.items);
    });
  }

  reviewRow(quotation:any){
    this.router.navigate(['/transactions/sales-quotation/view', quotation.id]);
  }

  pageChanged(event: PageEvent) {
    
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getSalesQuotaions();
  }

  createSalesQuotation() 
  {
    this.router.navigate(['/transactions/sales-quotation/create']);

  }

  updateSalesQuotation(quotation: any) {
    this.router.navigate(['/transactions/sales-quotation/edit', quotation.id]);
  
  }

  deleteSalesQuotation(quotation: any) {
    // if(vehicles.some(vehicle => vehicle.isActive) == true)
    //   {
    //     Swal.fire(this.translateService.instant("CANT_DELETE_ACTIVE_ITEM.TEXT"),"", 'warning');
    //     return; 
    //   }

    Swal.fire({
      title: this.translateService.instant("ARE_YOU_SURE.TEXT"),
      text: this.translateService.instant("YOU_WONT_BE_ABLE_TO_REVERT_THIS.TEXT"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
      cancelButtonText: this.translateService.instant("CANCEL.TEXT"),
      confirmButtonText: this.translateService.instant("YES_DELETE_IT.TEXT")
    }).then(result => {
      if (result.value) {
        this.salesQuotationService.deleteSalesQuotation(quotation.id).pipe(takeUntil(this.destroy$)).subscribe(response => {
          if(response.statusCode === 200){
            Swal.fire(this.translateService.instant("Sales-Quotation_DELETED_SUCCESSFULLY.TEXT"),"", 'success');
            this.getSalesQuotaions();
          } else {
            Swal.fire(this.translateService.instant("SOMETHING_WENT_WRONG.TEXT"), this.translateService.instant("PLEASE_CONTACT_ADMIN.TEXT"), 'error')
          }
        })
        //vehicles.forEach(vehicle => this.selection.deselect(vehicle));
      }
    }); 
  }


  copySelectedRow(quotation:any){
    this.router.navigate(['/transactions/sales-quotation/copy', quotation.id]);
  }

  

  onTypingFinished(value: string) {
    console.log('Finished typing:', value);
    this.onFilterChange(value)
    // Your search/filter logic here
  }

  onKeyup(event: any) {
    // Clear the timer on every keyup to reset the delay
    clearTimeout(this.typingTimer);
    
    // Set the timer to trigger after `doneTypingInterval` ms
    this.typingTimer = setTimeout(() => {
      this.onTypingFinished(event.target.value);
    }, this.doneTypingInterval);
  }

  onFilterChange(value: string) {
    // debugger
    if (!this.dataSource) {
      return;
    }
    this.currentPage=0;
    value = value.trim();
    value = value.toLowerCase();
    this.getSalesQuotaions(value);
    //this.dataSource.filter = value;
  }

  toggleColumnVisibility(column, event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }

  getStatusClasses(status: string):{ textClass: string; bgClass: string } | undefined{
    return this.salesQuotationInternalService.getStatusClasses(status,0);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    //const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    //return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    //this.isAllSelected() ?
      //this.selection.clear() :
      //this.dataSource.data.forEach(row => this.selection.select(row));
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  loadData(criteria = null,status) {
    //this.isLoading = true;
    this.filteredDataStatus=status;
    // this.vehicleService.getPaginatedVehicles(this.currentPage, this.pageSize, true, criteria,status).subscribe(response => {
    //   this.dataSource.data = response.data.vehicles;
    //   console.log( this.dataSource.data);
    //   this.activeCount = response.data.vehicles.length;
    //   setTimeout(() => {
    //     this.paginator.pageIndex = this.currentPage;
    //     this.paginator.length = response.data.count;
    //   });
    //   this.isLoading = false;
    // })
  }

  
}
